import React, { useEffect } from 'react'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import M_ButtonNormal from 'components/1_Atoms/2_Molecules/M_ButtonNormal'
import O_TablePagination from './O_TablePagination'
import { organismLog } from 'utils/logUtil'
import { buttonInfo } from 'types/FunctionTypes'
import { useMediaQueryContext } from 'MediaQueryProvider'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    hit: {
      marginRight: theme.spacing(1),
    },
    button1: {
      // flexGrow: 1,
      // width: 190
    },
    button2: {
      backgroundColor: 'red',
    },
    paddingRight0: {
      paddingRight: '0px',
    },
  }),
)
const margin = 0
const paddingX = 0.5
const paddingY = 0

type Props = {
  count: number
  buttonInfos: buttonInfo[]
  pagination?: boolean
}

const O_TableBar = ({ count = 0, buttonInfos, pagination = false }: Props) => {
  useEffect(() => organismLog('O_TableBarSummary'))
  const classes = useStyles()
  const { isMobileSite } = useMediaQueryContext()
  const kenMsg = `${count}件${isMobileSite ? '' : ' 見つかりました。'}`

  return (
    <div className={classes.root}>
      <Toolbar variant="dense" className={classes.paddingRight0}>
        <Typography className={classes.hit} color="inherit" variant="subtitle1" component="div">
          {kenMsg}
        </Typography>
        {buttonInfos.map((buttonInfo) => {
          return (
            <Box m={margin} px={paddingX} py={paddingY}>
              <M_ButtonNormal
                label={buttonInfo.label} //
                event={buttonInfo.click}
                disabled={buttonInfo.disabled}
                alert={buttonInfo.alert}
              />
            </Box>
          )
        })}
        <Box className={classes.root}></Box>
        <Box>{pagination ? <O_TablePagination count={count} isDetail={false} /> : null}</Box>
      </Toolbar>
    </div>
  )
}

export default React.memo(O_TableBar)
